var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"gz-footer"},[_c('div',{staticClass:"gz-footer__container gz-page__width"},[_c('GZ-Copyrights')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }